















































































import { defineComponent } from '@vue/composition-api';
import { Rules } from '../../types/Rules';
import HeaderLogo from '@/components/HeaderLogo/HeaderLogo.vue';

export default defineComponent({
  name: 'Rules',
  props: {
    rules: Object as () => Rules,
  },
  components: {
    HeaderLogo,
  },
});
